var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "track-rocl"
    },
    [
      _vm.logisTraceData.message != null
        ? _c("div", [_c("span", [_vm._v(_vm._s(_vm.logisTraceData.message))])])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "track-list" }, [
        _c(
          "ul",
          _vm._l(_vm.logisTraceData.traces, function(logisTrace, index) {
            return _c(
              "li",
              { staticClass: "afterdate", class: { first: index == 0 } },
              [
                _c("i", { staticClass: "node-icon" }, [_vm._v("•")]),
                _vm._v(" "),
                _c("span", { staticClass: "date" }, [
                  _vm._v(_vm._s(logisTrace.time))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "txt" }, [
                  _vm._v(_vm._s(logisTrace.name))
                ])
              ]
            )
          })
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-072507d5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-072507d5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/LogisTraceInfo.vue
// module id = 2959
// module chunks = 0